import {
  closeModal as modalClose,
  openModal as modalOpen,
} from '@/features/slice/event/event-slice';

import { MODAL_ROUTE } from '../constants';
import { useAppDispatch, useAppSelector } from '../features';

export const useModal = () => {
  const dispatch = useAppDispatch();

  const openModal = (
    modalName: (typeof MODAL_ROUTE)[keyof typeof MODAL_ROUTE],
    data?: any,
  ) => {
    dispatch(
      modalOpen({
        content: modalName,
        data: data,
      }),
    );
  };

  const modalData = useAppSelector((store) => store.eventSlice.modalData);

  const closeModal = () => {
    dispatch(modalClose());
  };

  return {
    openModal,
    closeModal,
    modalData,
  };
};
